require('./alert-modal.component.scss');

export const AlertModalController = function (
  $scope,
  $modalInstance,
  errorStatus,
  errorText,
) {
  $scope.errorStatus = errorStatus;
  $scope.errorText = errorText;
  $scope.textButton = gettext('Ок');
  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };
};



// WEBPACK FOOTER //
// ./src/filter/editor/alert-modal.component.js